import { decodeBase64Url, encodeBase64Url } from './encode-base64';
import { MissingRequiredParameterError } from './errors';
import { commonIntegrationDataToQuery, integrationDataFromQuery } from './integration-data';
export function planCustomizationDataFromQuery(query) {
  const planId = query.get('planId') ?? undefined;
  const pricingVariantId = query.get('pricingVariantId') ?? undefined;
  const planSlug = query.get('planSlug') ?? undefined;
  const checkoutFlowId = query.get('checkoutFlowId') ?? undefined;
  const isAddToCart = query.get('isAddToCart') === 'true' ? true : undefined;
  const returnUrl = query.get('returnUrl') ?? undefined;
  const _additionalLineItemsF = additionalLineItemsFromQuery(query),
    additionalLineItems = _additionalLineItemsF.additionalLineItems,
    additionalLineItemsError = _additionalLineItemsF.additionalLineItemsError;
  const _integrationDataFromQ = integrationDataFromQuery(query),
    navigateTo = _integrationDataFromQ.navigateTo,
    navigateToPageProps = _integrationDataFromQ.navigateToPageProps,
    navigateToSectionProps = _integrationDataFromQ.navigateToSectionProps,
    maxStartDate = _integrationDataFromQ.maxStartDate,
    minStartDate = _integrationDataFromQ.minStartDate,
    biOptions = _integrationDataFromQ.biOptions,
    verticalStatusContent = _integrationDataFromQ.verticalStatusContent;
  const integrationData = {
    navigateTo,
    navigateToPageProps,
    navigateToSectionProps,
    minStartDate,
    maxStartDate,
    biOptions,
    verticalStatusContent
  };
  if (planId) {
    return {
      ...integrationData,
      planId,
      pricingVariantId,
      checkoutFlowId,
      isAddToCart,
      returnUrl,
      additionalLineItems,
      additionalLineItemsError,
      planSlug: undefined
    };
  } else if (planSlug) {
    return {
      ...integrationData,
      planSlug,
      pricingVariantId,
      checkoutFlowId,
      isAddToCart,
      returnUrl,
      additionalLineItems,
      additionalLineItemsError,
      planId: undefined
    };
  } else {
    throw new MissingRequiredParameterError('planId', 'planSlug');
  }
}
function additionalLineItemsFromQuery(query) {
  const raw = query.get('additionalLineItems');
  if (!raw) {
    return {};
  }
  try {
    return {
      additionalLineItems: decodeBase64Url(raw)
    };
  } catch {
    return {
      additionalLineItemsError: true
    };
  }
}
export function planCustomizationDataToQuery(data) {
  var _data$additionalLineI;
  const query = commonIntegrationDataToQuery(data.integrationData);
  query.set('planId', data.planId);
  data.checkoutFlowId && query.set('checkoutFlowId', data.checkoutFlowId);
  data.isAddToCart && query.set('isAddToCart', 'true');
  data.returnUrl && query.set('returnUrl', data.returnUrl);
  data.pricingVariantId && query.set('pricingVariantId', data.pricingVariantId);
  ((_data$additionalLineI = data.additionalLineItems) == null ? void 0 : _data$additionalLineI.length) && query.set('additionalLineItems', encodeBase64Url(data.additionalLineItems));
  return query;
}
//# sourceMappingURL=plan-customization-data.js.map